<template>
  <div v-if="selectedCount > 0" class="planning-bulk-panel">
    <div class="planning-bulk-panel__form">
      <div class="planning-bulk-panel__selection-bar">
        <span class="planning-bulk-panel__selection-count">{{ selectedCount }} geselecteerd</span>
        <span v-if="selectionSummary.clusterCity" class="planning-bulk-panel__selection-meta">
          · {{ selectionSummary.clusterCity }}
        </span>
        <span v-if="selectionSummary.totalDuration" class="planning-bulk-panel__selection-meta">
          · {{ formatMinutes(selectionSummary.totalDuration) }}
        </span>
      </div>

      <div class="planning-bulk-panel__actions">
        <Btn
          v-if="selectionSummary.tentativeCount > 0"
          size="sm"
          variant="secondary"
          icon="check"
          :text="`Bevestigen (${selectionSummary.tentativeCount})`"
          :loading="loading && activeAction === 'confirm'"
          @click="$emit('bulk-confirm')"
        />
        <Btn
          size="sm"
          variant="outlined"
          icon="trash"
          text="Verwijderen"
          :loading="loading && activeAction === 'delete'"
          @click="$emit('bulk-delete')"
        />
        <Btn
          size="sm"
          variant="primary"
          icon="calendar"
          text="Planningsvoorstel"
          @click="$emit('plan')"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Btn from '@/components/partials/Btn.vue';

  export default {
    name: 'PlanningBulkActionPanel',
    components: { Btn },
    props: {
      selectedCount: { type: Number, default: 0 },
      selectionSummary: {
        type: Object,
        default: () => ({ totalDuration: 0, tentativeCount: 0 }),
      },
      loading: { type: Boolean, default: false },
      activeAction: { type: String, default: null },
    },
    emits: ['bulk-confirm', 'bulk-delete', 'plan'],
    setup() {
      const formatMinutes = (mins) => {
        const h = Math.floor(mins / 60);
        const m = mins % 60;
        if (h && m) return `${h}u ${m}m`;
        if (h) return `${h}u`;
        return `${m}m`;
      };

      return { formatMinutes };
    },
  };
</script>

<style scoped lang="scss">
  .planning-bulk-panel {
    flex-shrink: 0;
    border-top: 1px solid var(--slate-200);
    background: var(--slate-50);

    &__form {
      padding: 0.75rem 1rem 1rem;
    }

    &__selection-bar {
      display: flex;
      align-items: center;
      gap: 0.375rem;
      margin-bottom: 0.5rem;
      font-size: 0.8125rem;
    }

    &__selection-count {
      font-weight: 600;
      color: var(--slate-800);
    }

    &__selection-meta {
      color: var(--slate-500);
    }

    &__actions {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      flex-wrap: wrap;
    }
  }
</style>
